

const state = () => ({
    patologicsections: [],
    patological: [],
})

export default state